import { Injectable } from '@angular/core';
import { NotificationBarItem } from './notification-bar-item';
import { UrlBuilder } from '../core/url-builder/url-builder';
import { Observable, ConnectableObservable, combineLatest } from 'rxjs';
import { map, publishReplay } from 'rxjs/operators';
import { sumBy } from 'lodash';
import { CategoriesStorage } from '../documents';
import { GeneralUnreadReportsStorage } from '../general-documents/general-unread-reports-storage';

@Injectable()
export class NotificationBarContent {
    public get items(): Observable<NotificationBarItem[]> {

        // No need for unsubscribe.
        // It's always used. There is at least one layout component (dashboard-level-layout or site-level-layout) subscribed on items.
        // Both layout components will be destroyed but only after page closing.
        this.allNotificationsBatItems.connect();

        return this.allNotificationsBatItems;
    }

    private readonly allNotificationsBatItems: ConnectableObservable<NotificationBarItem[]>;

    constructor(
        unreadReportsRegistry: GeneralUnreadReportsStorage,
        private categoriesStorage: CategoriesStorage,
        private urlBuilder: UrlBuilder
    ) {
        this.allNotificationsBatItems =
            combineLatest(this.categoriesStorage.generalCategories, unreadReportsRegistry.allUnread)
                .pipe(
                    map(([generalCategories, allUnread]) =>
                        generalCategories.map(c => {
                            const categories = allUnread.filter(u => u.rootCategoryId === c.categoryId);
                            const unreadReportCounter = sumBy(categories, r => r.totalUnread);
                            const totalDocs = sumBy(categories, r => r.totalDocs);
                            return new NotificationBarItem(c, this.urlBuilder, totalDocs, unreadReportCounter);
                        })
                    ),
                    publishReplay(1)
                ) as ConnectableObservable<NotificationBarItem[]>;
    }
}